import { render, staticRenderFns } from "./UncapturedOrdersPage.vue?vue&type=template&id=9a0aeb34&scoped=true"
import script from "./UncapturedOrdersPage.vue?vue&type=script&lang=js"
export * from "./UncapturedOrdersPage.vue?vue&type=script&lang=js"
import style0 from "./UncapturedOrdersPage.vue?vue&type=style&index=0&id=9a0aeb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0aeb34",
  null
  
)

export default component.exports